import { render, staticRenderFns } from "./CollegiateMsg.vue?vue&type=template&id=0b3df18d&scoped=true"
import script from "./CollegiateMsg.vue?vue&type=script&lang=js"
export * from "./CollegiateMsg.vue?vue&type=script&lang=js"
import style0 from "./CollegiateMsg.vue?vue&type=style&index=0&id=0b3df18d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3df18d",
  null
  
)

export default component.exports